<template>
  <div
    class="controlsCom mainPageBg subsystemCommon"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenuBox">
      <AirMenu @getActiveItem="getActiveItem" ref="airMenuCom" />
    </div>
    <ControlCom
      v-if="type == '末端'"
      ref="endControlCom"
      :treeActive="treeActive"
    />
    <MachineRoom v-if="type == '机房'" :treeAllData="treeAllData" />
    <AirStrategy
      v-if="type == '策略'"
      :treeAllData="treeAllData"
      @listenInRenew="listenInRenew"
    />
  </div>
</template>

<script>
import AirMenu from "@/components/zixitong/airSystem/control/AirMenu.vue";
import MachineRoom from "@/components/zixitong/airSystem/control/MachineRoom.vue";
import AirStrategy from "@/components/zixitong/airSystem/control/AirStrategy.vue";
import ControlCom from "@/components/zixitong/ControlCom.vue";
export default {
  components: {
    AirMenu,
    MachineRoom,
    AirStrategy,
    ControlCom,
  },
  data() {
    return {
      treeActive: {},
      type: "",
      treeAllData: {},
    };
  },

  methods: {
    getActiveItem(data) {
      // console.log("目录选择数据", data);
      this.type = "";
      this.treeActive = {};
      setTimeout(() => {
        this.type = data.active;
        if (!data.treeActive.id) {
          return;
        }
        this.treeActive = Object.assign({}, data.treeActive, {
          systemName: "风机盘管,分体式空调",
        });
        this.treeAllData = data;
        this.$nextTick(() => {
          if (this.type == "末端") {
            this.$refs.endControlCom.handleData();
          }
        });
      }, 10);
    },
    listenInRenew() {
      this.$refs.airMenuCom.getStrategyList();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
